import React from 'react'
import LoginForm from '../../components/LoginForm'
import { Row, Col } from "antd";
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import logo_white from '../../../../assets/images/logow.png'
const backgroundURL = '/img/others/img-17.jpg'
const backgroundStyle = {
	backgroundImage: `url(${backgroundURL})`,
	backgroundRepeat: 'no-repeat',
	backgroundSize: 'cover'
}

const LoginTwo = props => {

	const theme = useSelector(state => state.theme.currentTheme)

	return (
		<div className="auth-container">
		<div className={`h-100 bg`}>
			<Row justify="center" className="align-items-stretch h-100">
				<Col xs={0} sm={0} md={0} lg={8}>
					<div className="d-flex flex-column justify-content-center h-100 px-4" style={backgroundStyle}>
						{/* <div className="text-right">
						<img src={logo_white} alt="logo"/></div> */}
						<Row justify="center">
							<Col xs={0} sm={0} md={0} lg={20}>
								<img className="img-fluid mb-5" src="/img/others/img-18.png" alt=""/>
								<h1 className="text-white">Welcome to OneATS</h1>
								<p className="text-white">
									Manage your entire recruitment lifecycle in one place with One Applicant Tracking System.
									Transform your recruitment process to find, hire and retain the best candidates. 
								</p>
							</Col>
						</Row>
					
					</div>
				</Col>
				<Col xs={24} sm={24} md={24} lg={16}>
					<div className="container d-flex flex-column justify-content-center h-100">
						<Row justify="center">
							<Col xs={24} sm={24} md={20} lg={16} xl={10}>
								<div className='signup-card p-5'>
									<h1>Sign In</h1>
									<p>Don't have an account yet? <a className='text-primary' href="/auth/register">Sign Up</a></p>
									<div>
										<LoginForm {...props}/>
									</div>
								</div>
							</Col>
						</Row>
					</div>
				</Col>
			</Row>
		</div>
		</div>
	)
}

export default withRouter(LoginTwo)